const setupToc = () => {
	/* Display current section in table of contents for pillar pages */
	const tocContainer = document.querySelector('.toc');

	if (!tocContainer) {
		console.warn('Toc container not found');
		return;
	}

	const pageAnchors = document.querySelectorAll('a.is-page-anchor');
	const tocLinks = tocContainer.querySelectorAll('ul li a');
	const tocItems = tocContainer.querySelectorAll('ul li');

	/* Select content title and add active class to current section in the table of contents */
	function updateToc() {
		const scrollPosition = window.scrollY;
		let currentAnchorId = null;

		/* Convert to array to access next anchor */
		const anchorsArray = Array.from(pageAnchors);

		for (const [i, anchor] of anchorsArray.entries()) {
			const offsetTop = anchor.offsetTop - (window.innerHeight / 3);

			/* Use next anchor as section end, or end of page for last anchor */
			const sectionEnd = i < anchorsArray.length - 1 ? anchorsArray[i + 1].offsetTop : document.body.scrollHeight;

			if (scrollPosition >= offsetTop && scrollPosition < sectionEnd) {
				currentAnchorId = anchor.id;
			}
		}

		/* Remove is-selected from all li elements */
		for (const item of tocItems) {
			item.classList.remove('is-selected');
		}

		/* Add is-selected to the li element that contains the matching link */
		if (currentAnchorId) {
			for (const link of tocLinks) {
				if (link.getAttribute('href') === `#${currentAnchorId}`) {
					link.parentNode.classList.add('is-selected');
				}
			}
		}
	}

	/* Only run on pages that have table of contents */
	if (tocLinks.length > 0 && pageAnchors.length > 0) {
		window.addEventListener('scroll', updateToc);
		updateToc();
	}

	/* Open/close table of content menu */
	const tocBurger = document.querySelector('.toc-burger');
	const tocBurgerClose = tocContainer.querySelector('.toc-burger-close');

	tocBurger?.addEventListener('click', () => {
		tocContainer.classList.add('is-active');
	});

	tocBurgerClose?.addEventListener('click', () => {
		tocContainer.classList.remove('is-active');
	});

	for (const item of tocLinks) {
		item.addEventListener('click', () => {
			tocContainer.classList.remove('is-active');
		});
	}
};

document.addEventListener('DOMContentLoaded', () => {
	setupToc();
});
